import { Request, getParamsUrl } from '@/core'
import { notifications } from '@/constants/urls'

export default {
  getUnreadQuantity: async () => Request.get(notifications.unread),

  getNoticeList: async params => {
    const paramsFormatted = getParamsUrl(params)

    return Request.get(`${notifications.list}${paramsFormatted}`)
  },

  setRead: async data => Request.post(`${notifications.markRead}`, data),
}
